import { useState, type FormEvent } from "react";
import { api, errorText } from "../api";
import type { TenantIdentity } from "../types";
import { Brand } from "./Icons";

/* The tenant is named here because on a platform the same login form appears on
   every subdomain — somebody with two instances open should be able to tell at
   a glance which password they are being asked for. */
export function Login({
  tenant,
  onSignedIn,
}: {
  tenant: TenantIdentity;
  onSignedIn: () => void;
}) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api("/api/login", {
        method: "POST",
        body: JSON.stringify({ name, password }),
      });
      onSignedIn();
    } catch (problem) {
      setError(errorText(problem));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section id="login">
      <form onSubmit={submit}>
        <Brand name={tenant.display_name} />
        <h1>Sign in</h1>
        <p>
          Pick a display name and enter the password {tenant.display_name} gave
          you.
        </p>
        <input
          type="text"
          placeholder="Display name"
          autoComplete="nickname"
          required
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <button type="submit" disabled={busy}>
          Enter
        </button>
        <div id="login-error">{error}</div>
      </form>
    </section>
  );
}
